(() => {
  if (customElements.get('sg-pot-purchasing')) return;
  class PotPurchasing extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.scope = this.closest('[data-section-type="product"]') || this.closest('.shopify-section');
      this.data = JSON.parse(this.querySelector('[data-pot-data]').textContent);
      const start = () => {
        if (!this.isConnected || !this.scope) return;
        this.selects = [...this.scope.querySelectorAll('.product__variants-wrapper select[name^="options["]')];
        if (!this.selects.length && this.data.variants[0]?.options[0] !== 'Default Title') return;
        this.scope.setAttribute('data-sg-pot-ready', '');
        this.hidden = false;
        this.refresh();
      };
      this.addEventListener('change', event => {
        const input = event.target.closest('[data-pot-value]');
        if (!input) return;
        const index = Number(input.closest('[data-pot-option]').dataset.potOption);
        const options = this.selects.map(select => select.value);
        options[index] = input.value;
        const exact = this.match(options);
        const next = exact?.available ? exact : this.data.variants.find(variant => variant.available && variant.options[index] === input.value);
        if (!next) { this.refresh(); return; }
        this.selects.forEach((select, i) => { select.value = next.options[i]; });
        this.selects[index].dispatchEvent(new Event('change', { bubbles: true }));
        this.refresh();
      }, { signal });
      this.scope?.addEventListener('change', event => {
        if (event.target.matches('select[name^="options["],select[name="id"]')) this.refresh();
      }, { signal });
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-pot-sibling]');
        if (link?.getAttribute('aria-current') === 'true') event.preventDefault();
      }, { signal });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal });
      else start();
      window.addEventListener('load', start, { once: true, signal });
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant');
        const next = this.data.variants.find(variant => String(variant.id) === id);
        if (!next || !this.selects?.length) return;
        this.selects.forEach((select, i) => { select.value = next.options[i]; });
        this.selects[0].dispatchEvent(new Event('change', { bubbles: true }));
        this.refresh();
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    match(options) {
      return this.data.variants.find(variant => variant.options.every((value, i) => value === options[i]));
    }
    refresh() {
      if (!this.selects) return;
      const options = this.selects.map(select => select.value);
      const selected = this.match(options) || this.data.variants[0];
      this.querySelectorAll('[data-pot-option]').forEach(fieldset => {
        const index = Number(fieldset.dataset.potOption);
        fieldset.querySelectorAll('[data-pot-value]').forEach(input => {
          input.checked = selected.options[index] === input.value;
          const values = [...selected.options];
          values[index] = input.value;
          const exact = this.match(values);
          const candidate = exact?.available ? exact : this.data.variants.find(variant => variant.available && variant.options[index] === input.value);
          input.disabled = !candidate;
          const price = input.closest('label').querySelector('[data-pot-size-price]');
          if (price) price.innerHTML = candidate?.price || (exact ? this.data.soldOut : this.data.unavailable);
          const image = input.closest('label').querySelector('.sg-pot-colour-image');
          const swatch = exact || candidate;
          if (image && swatch?.image && image.getAttribute('src') !== swatch.image) {
            image.removeAttribute('srcset');
            image.src = swatch.image;
          }
        });
      });
      const clean = value => String(value).toLowerCase().replace(/diameter/g, 'd').replace(/height/g, 'h').replace(/[^a-z0-9.]/g, '');
      this.querySelectorAll('[data-pot-sibling]').forEach(link => {
        const sibling = this.data.siblings.find(item => String(item.id) === link.dataset.potSibling);
        if (!sibling) return;
        const variant = sibling.variants.find(item => clean(item.size) === clean(selected.options[0])) || sibling.variants.find(item => item.available) || sibling.variants[0];
        if (!variant) return;
        const image = link.querySelector('.sg-pot-colour-image');
        if (image && variant.image && image.getAttribute('src') !== variant.image) {
          image.removeAttribute('srcset');
          image.src = variant.image;
        }
        const url = new URL(link.dataset.potUrl, location.origin);
        url.searchParams.set('variant', variant.id);
        const current = new URL(location.href);
        if (current.searchParams.has('view')) url.searchParams.set('view', current.searchParams.get('view'));
        else url.searchParams.set('view', 'pot-template-1');
        if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
        link.href = url.pathname + url.search;
      });
      const summary = selected.options.filter(value => value !== 'Default Title').join(' · ');
      this.querySelector('[data-pot-summary]').textContent = summary ? this.data.selectedLabel + ': ' + summary : '';
    }
  }
  customElements.define('sg-pot-purchasing', PotPurchasing);
})();
